
import type { ImageSrc } from '../models/image-src';

export function srcset(images: ImageSrc[]) {
  if (!images || images.length === 0) {
    return '';
  }
  return images.map((image) => `${image.url} ${image.width}w`).join(', ');
}